import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=1dd09e5e"
import script from "./addCategory.vue?vue&type=script&lang=js"
export * from "./addCategory.vue?vue&type=script&lang=js"
import style0 from "./addCategory.vue?vue&type=style&index=0&id=1dd09e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports